<script>

    import {createEventDispatcher} from "svelte";
    import {t} from "../core/i18n/language-store.js";
    const dispatch = createEventDispatcher();

    export let opened = false;
    export let favoritesList = [];
    export let favoritesFilterApplied = false;

    let allergenFilters = [
        {key: "Avocado", label: "Avocado"},
        {key: "Peanuts", label: "Peanuts"},
        {key: "gluten", label: "gluten"},
        {key: "Mustard", label: "Mustard"},
        {key: "Sulphur dioxide", label: "Sulphur dioxide"},
        {key: "Sesame", label: "Sesame"},
        {key: "Lupin", label: "Lupin"},
        {key: "Molluscs", label: "Molluscs"},
        {key: "Milk", label: "Milk"},
        {key: "Nuts", label: "Nuts"},
        {key: "Crustaceans", label: "Crustaceans"},
        {key: "Fish", label: "Fish"},
        {key: "Celery", label: "Celery"},
        {key: "Soya", label: "Soya"},
        {key: "Eggs", label: "Eggs"}
    ];
    let appliedFiltersCount = allergenFilters.length;

    $: {
        dispatch('filter', {
            hide: allergenFilters.filter(x => x.selected === false).map(x => x.key)
        });
    }

    function toggleDropdown () {
        opened = !opened;
        if (!opened) {
            dispatch('close');
        }
    }

    function toggleFilter (filter) {


        allergenFilters = allergenFilters.map(f => {
            if (f === filter) {
                if (f.selected === undefined) {
                    f.selected = false;
                }
                else {
                    f.selected = !f.selected;
                }
            }
            return f;
        });

        appliedFiltersCount = allergenFilters.filter(x => !x.selected).length;
    }

    function filterFavorites () {
        favoritesFilterApplied = !favoritesFilterApplied;
        dispatch('filterFavorites', {favoritesFilterApplied});
    }

</script>

<style>

    .title {
        padding: 0 1.25rem .5rem 1.25rem;
    }

    .filters-container {
        overflow: hidden;
    }
    .filters {
        margin-top: -100%;
        opacity: 0;
        transition: margin-top .3s ease-in-out, opacity .15s .15s ease-in-out;
    }
    .filters--opened {
        margin-top: 0;
        opacity: 1;
    }

    ul {
        display: flex;
        flex-wrap: wrap;

        align-items: center;
        overflow-y: scroll;
        gap: .5rem;
        width: 100%;
        padding: .5rem 1.25rem 1rem 1.25rem;
        margin-bottom: 1rem;
    }
    li {
        white-space: nowrap;
        background: var(--filter-active-color);
        color: white;
        padding: 0.5rem 0.75rem;
        border-radius: var(--border-radius-xxl);
        border: 1px solid transparent;
        box-shadow: 0 4px 8px 0 #1a1f5185;
        transition: background-color .2s ease-in-out;
    }
    li.filtered-out {
        color: #777987;
        border: 1px solid rgb(213 215 230 / 52%);
        box-shadow: none;
        background: var(--filter-disabled-color);
        text-decoration: line-through;
    }
</style>

<div class="filters-container layer-filters">
    <div class="filters {opened ? 'filters--opened' : ''}">

        <div class="title">{$t('filters.allergens')}</div>
        <ul>
            {#each allergenFilters as filter}
                <li class="filter pointer {filter.selected === false ? 'filtered-out' : ''}"
                    on:click={() => toggleFilter(filter)}>
                    {$t('allergens.' + filter.key )}
                </li>
            {/each}
        </ul>

    </div>
</div>
